<template>
    <section class="p-5 pt-10 md:pt-16">
        <div class="text-center">
            <div class="clear--sm"></div>
            <h2 class="pb-4 pt-20" v-text="$t('OPTOUT_MESSAGE')"></h2>
        </div>
    </section>
</template>

<script>
import ReferralService from '@/services/users/ReferralService';

export default {
    name: 'EmailOptOut',
    data() {
        return {
            referralId: null,
        };
    },
    mounted() {
        const referralService = new ReferralService();

        referralService.updateOptOut(Number(this.$route.params.referralId));
    },
};
</script>
